import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import CrawlErrorsRow from '../CrawlErrorsRow';

export class CrawlErrorsTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        httpStatusCategory: PropTypes.shape({
          CrawlErrors: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const toggle = get(this.props.project, 'crawls.edges[0].node.countCodesCrawlErrors', []);
    const toggleFilter = (toggle || []).map(v => ({ identifier: v.error, label: v.error, ...v }));

    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('errors', toggleFilter)}
            checkedItems={this.props.filters.errors}
            groups={toggleFilter}
            name='errors'
            label={<Translate content='crawler_crawl_error_issue' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('url')}
            value={this.props.filters.url}
            name='url'
            label={<Translate content='crawler_crawl_error_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='httpStatusCategory' section='crawlErrors'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_crawl_error_issue' size='4' />
            <Translate content='crawler_source_page_url' size='3' />
            <Translate content='crawler_crawl_error_page_url' size='3' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={CrawlErrorsRow} />
        </CrawlerTable>
      </>
    );
  }
}

const I18nCrawlErrorsTable = (withFilters)(CrawlErrorsTable);

export default createRefetchContainer(
  I18nCrawlErrorsTable,
  {
    project: graphql`
      fragment CrawlErrorsTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
        errors: {type: "[String]", defaultValue: []}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              crawlErrors (offset: $offset, limit: $limit, url: $url, errors: $errors, sourceUrl: $sourceUrl) {
                count
                edges {
                  node {
                    ...CrawlErrorsRow_issue
                  }
                }
              },
              countCodesCrawlErrors(url: $url, sourceUrl: $sourceUrl) {
                error,
                count
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query CrawlErrorsTable_RefetchQuery(
        $offset: Int,
        $limit: Int,
        $url: TextFilters,
        $sourceUrl: TextFilters,
        $errors: [String],
        $host: String!
      ) {
        project (host: $host) {
          ...CrawlErrorsTable_project @arguments(
            offset: $offset,
            limit: $limit,
            url: $url,
            sourceUrl: $sourceUrl,
            errors: $errors
          )
        }
      }
    `
);
